import { RouteName, RouteNames } from './routes';

// This is the cooldown for resending Auth0 invites
export const RESEND_AUTH0_INVITE_COOLDOWN_MINUTES = 5;

// This is the cooldown for resending regular invites
export const RESEND_INVITE_COOLDOWN_HOURS = 1;

export interface OnboardingStep {
  name: RouteName;
  title: string;
  subtitle: string;
  isComplete: boolean;
  percentComplete: number;
}

export const invitedUserOnboardingSteps: Record<string, OnboardingStep> = {
  [RouteNames.ONBOARDING.INVITED.USER_DETAILS]: {
    name: RouteNames.ONBOARDING.INVITED.USER_DETAILS,
    title: 'Welcome',
    subtitle: `Let's learn more about you!`,
    isComplete: false,
    percentComplete: 25,
  },
  [RouteNames.ONBOARDING.INVITED.VERIFICATION]: {
    name: RouteNames.ONBOARDING.INVITED.VERIFICATION,
    title: 'Verify your identity',
    subtitle:
      'Additional information will help us properly verify your identity and better protect your business.',
    isComplete: false,
    percentComplete: 50,
  },
  [RouteNames.ONBOARDING.INVITED.ID]: {
    name: RouteNames.ONBOARDING.INVITED.ID,
    title: `You're almost there. One more step!`,
    subtitle:
      'Additional information will help us properly verify your identity and better protect your business.',
    isComplete: false,
    percentComplete: 75,
  },
  [RouteNames.ONBOARDING.INVITED.REVENUE_ACCOUNT]: {
    name: RouteNames.ONBOARDING.INVITED.REVENUE_ACCOUNT,
    title: 'Connect your revenue account',
    subtitle:
      'Connect your sales accounts to help us better understand your business.',
    isComplete: false,
    percentComplete: 90,
  },
};
